// extracted by mini-css-extract-plugin
export default {"wrapper":"ShiftCalendarConfiguration_wrapper__lAsBJ","col":"ShiftCalendarConfiguration_col__Ot8ze"};